import type { RouteObject } from 'react-router-dom';

import { setPermissions } from '@/features/auth/authStore';
import { routes } from '@/router';
import { transformElegantRouteToReactRoute } from '@/router/common/transform';
import { AuthService } from '@/service/api';
import { store } from '@/store';

import { getUserInfo } from '../auth';

interface InheritAttrs {
  sideShow?: boolean;
}
const routerDataHander = (treeList: Entity.Menus.ItemDto[], inheritAttrs: InheritAttrs = {}) => {
  const newTreeList: Router.RouterData[] = [];
  treeList.forEach(tree => {
    const newTree: Router.RouterData = {
      component: tree.component,
      errorBoundary: tree.error_boundary,
      fallback: tree.fallback,
      handle: {
        activeMenu: tree.active_menu,
        hideInMenu: inheritAttrs.sideShow === false ? true : !tree.side_show,
        icon: tree.icon,
        title: tree.title
      },
      name: String(tree.id),
      path: tree.path,
      redirect: tree.redirect,
      type: tree.permission_type
    };
    if (tree.children && tree.children.length) {
      newTree.children = routerDataHander(tree.children, {
        sideShow: !newTree.handle!.hideInMenu
      });
    }
    newTreeList.push(newTree);
  });
  return newTreeList;
};

export async function initAuthRoutes(addRoutes: (parent: string | null, route: RouteObject[]) => void) {
  await getUserInfo();
  const { data } = await AuthService.getRoleMenus();
  const newMenus = routerDataHander(data!.menuList);
  store.dispatch(setPermissions(data!.permissionsList));
  addRoutes(
    'root',
    newMenus.flatMap(route => transformElegantRouteToReactRoute(routes[0], route))
  );
}
